<template>
  <v-dialog v-model="dialog" persistent max-width="500px">
    <v-card grid-list-md>
      <ModelTitle title="Assign Class Room" @close="close()" />
      <v-card-text>
        <v-row v-if="Student" no-gutters>
          <v-col cols="6">
            <div>Student</div>
            <div class="font-weight-bold text-capitalize">{{ Student.fullName }}</div>
          </v-col>
          <v-col cols="6" v-if="Student.ClassStudents.length" class="mb-5">
            <div>Class</div>
            <div class="font-weight-bold text-capitalize">{{ Student.ClassStudents[0].Class.name }}</div>
          </v-col>

          <v-col cols="12" sm="12">
            <v-autocomplete dense autofocus hide-details :items="ClassRoom" clearable item-text="name"
              v-model="selectedClassRoom" return-object label="Select Class Room" outlined>
              <!-- Custom slot for displaying items -->
              <template v-slot:item="{ item }">
                <div class="my-2">
                  <div class="caption">{{ item.Class.name }}</div>
                  <div class="font-weight-bold">{{ item.name }}</div>
                  <div v-if="item.ClassRoomTeachers && item.ClassRoomTeachers.length">
                    <div v-for="teacher in item.ClassRoomTeachers" :key="teacher.id">
                      <v-chip v-if="teacher.Teacher" small>{{ teacher.Teacher.name }}</v-chip>
                    </div>
                  </div>
                </div>

              </template>

            </v-autocomplete>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secondary" text @click="close()">Close</v-btn>
        <v-btn color="green lighten-1" :loading="loading" dark @click="submit()">save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import classRoomService from "@/modules/ClassRoom/service.js";
// import studentService from "@/modules/Student/service.js";

export default {
  props: {
    editDialog: {
      default: false,
    },
    Student: {
      type: Object,
    },
  },
  name: "Assign-Class-room-to-student",
  data() {
    return {
      ClassRoom: [],
      selectedClassRoom: null,
      loading: false,
      dialog: false,
    };
  },
  computed: {
    ...mapGetters("global", ["currentUser"]),
  },
  watch: {
    editDialog(val) {
      // this.Teacher = this.editTeacher;
      this.dialog = val;
      if (val) {

        this.getClassRoom();
      } 7.70
      // console.log('Student', this.Student)
    },
  },
  methods: {
    async submit() {
      let obj = {
        ClassRoomId: this.selectedClassRoom.id,
        StudentId: this.Student.id,
      };
      classRoomService
        .assignStudent(obj)
        .then(() => {
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            })
            .fire({
              icon: "success",
              title: "Student was assist to class room",
            });

          // this.StudentList.push(result.data);
          // this.empty();
          this.$emit("submit");
        })
        .catch((err) => {
          this.loading = false;
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            })
            .fire({
              icon: "error",
              title: err.data.message,
            });
        });

      this.selectedStudent = null;
    },
    getClassRoom() {
      let param = {}
      if (this.Student.ClassStudents.length) {
        param.ClassId = this.Student.ClassStudents[0].ClassId
      }

      return classRoomService.getAll(param).then((response) => {
        this.ClassRoom = response.data;
        // console.log("response Class room", this.ClassRoom);
        // this.ClassRoom = this.getFormattedClassRoomsWithTeachers(response.data);
        return response;
      });
    },
    // function to map through the teacher's array to get teacher's name
    // getFormattedClassRoomsWithTeachers(classRooms) {
    //   return classRooms.map(classRoom => {
    //     const teacherNames = classRoom.ClassRoomTeachers.map(t => t.Teacher.name).join(', ');
    //     return {
    //       ...classRoom,
    //       formattedName: `${classRoom.name} - Teachers: ${teacherNames}`
    //     };
    //   });
    // },
    close() {
      this.empty();
      this.$emit("close");
    },
    empty() {
      this.selectedClassRoom = null;
    },
  },
};
</script>

<style scoped></style>
